module.exports = __webpack_public_path__ + "img/logo.6ebe701c.png";